export const classes = {
  card: 'w-full place-between gap-2 px-6 py-3 shrink-0 rounded-2xl border border-solid border-black/10 bg-white/[0.82] shadow-aurora-card backdrop-blur-md dark:border-white/10 dark:bg-[#332e43]/[0.84] group-data-[compact]/tile:px-2 group-data-[compact]/tile:py-1 group-data-[compact]/tile:gap-1',
  contentWrapper:
    'flex gap-4 items-center min-w-0 group-data-[compact]/tile:gap-2',
  titleWrapper: 'flex flex-col min-w-0',
  name: 'font-bold text-xl text-taupe-3 truncate dark:text-mauve-1 group-data-[compact]/tile:text-sm',
  description:
    'text-sm text-taupe-2 font-medium max-w-[30vw] w-full truncate dark:text-mauve-2 group-data-[compact]/tile:hidden',
};
